import React from 'react';

import {
  fields,
  formUtil
} from 'iron-forge-react-modules';
import {
  Grid,
  Typography
} from '@mui/material';

import { FormModal } from 'modules';
import { useForm } from 'react-hook-form';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  customerId: string;

  onClose: () => void;
  onSave: () => void;
}

export const FC: React.FC<IProps> = props => {
  const form = useForm<types.IFormState>({
    defaultValues: {
      email: '',
      firstName: '',
      lastName: '',
      phoneNumber: ''
    }
  });
  const queryTuple = dataService.useQuery(props.customerId);
  const [saveCustomer, saveCustomerTuple] = dataService.useSaveCustomer(props.customerId);
  formUtil.useSetFormFields(queryTuple, form.setValue, [
    'firstName',
    'lastName',
    'email',
    'phoneNumber'
  ]);



  const processSubmit = React.useCallback(
    async (formState: types.IFormState) => {
      await saveCustomer(formState);
      props.onSave();
    },
    [
      props,
      saveCustomer
    ]
  );



  const loading = queryTuple.loading || saveCustomerTuple.loading;

  return (
    <FormModal.FC
      title={queryTuple.data.formState.firstName + ' ' + queryTuple.data.formState.lastName}
      onClose={props.onClose}
      onSubmit={form.handleSubmit(processSubmit)}
      isLoading={loading}>
      <Grid
        container
        spacing={1}>
        <Grid
          item
          xs={12}
          md={6}>
          <ControlledTextField
            isDisabled={loading}
            label="First Name"
            fieldKey="firstName"
            formControl={form.control}
            isRequired />
        </Grid>

        <Grid
          item
          xs={12}
          md={6}>
          <ControlledTextField
            isDisabled={loading}
            label="Last Name"
            fieldKey="lastName"
            formControl={form.control}
            isRequired />
        </Grid>

        <Grid
          item
          xs={12}
          md={12}>
          <ControlledTextField
            label="Email"
            fieldKey="email"
            isDisabled={queryTuple.data.isInNetSuite || loading}
            formControl={form.control}
            isRequired
            disableDefaultMargins={queryTuple.data.isInNetSuite} />

          {queryTuple.data.isInNetSuite && (
            <Typography variant="caption">
              Customers in NetSuite cannot have their emails changed here.
            </Typography>
          )}
        </Grid>

        <Grid
          item
          xs={12}
          md={12}>
          <ControlledTextField
            isDisabled={loading}
            label="Phone Number"
            fieldKey="phoneNumber"
            formControl={form.control}
            isRequired />
        </Grid>
      </Grid>
    </FormModal.FC>
  );
};
